import { FetchUserVerifyParam } from "@/Interfaces/I_userVerify";
import { customAxios } from "..";

export const fetchUserVerifyApi = (data: FetchUserVerifyParam) => 
  customAxios({
    url: 'hktv_koc/cms/accounts/verify',
    method: 'GET',
    params: data,
  })

export const putUserVerifyApi = (data: String[]) => 
  customAxios({
    url: 'hktv_koc/cms/accounts/verify',
    method: 'PUT',
    data: data,
  })

export const deleteUserVerifyApi = (param: String) => 
  customAxios({
    url: `hktv_koc/cms/accounts/verify/${param}`,
    method: 'DELETE',
  })
